<template>
  <div class="custom-rate">
    <span v-for="index in max" :key="index" @click="rate(index)" :class="{ active: index <= currentRating }">
      <slot :index="index - 1"></slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    max: {
      type: Number,
      default: 5,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentRating: this.value,
    };
  },
  methods: {
    rate(index) {
      this.currentRating = index;
      this.$emit('input', this.currentRating);
    },
  },
  watch: {
    value(newValue) {
      this.currentRating = newValue;
    },
  },
};
</script>

<style lang="less" scoped>
.custom-rate {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 5px;
  span {
    display: flex;
    cursor: pointer;
    color: white;
  }

  .active {
    color: #fadb14;
  }
}
</style>
